// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  // Приложение Edim: регистрация владельца (слайдер промо-заведения)
  appUrl: "https://dev.edim.app",
  metrikaId: null as number | null,
  // Основной проект (где собирается аналитика)
  useEmulators: false,
  // Dev: меню и данные — один проект dev-edim-app (сайт dev-edim-app-menu,
  // dev.edim.menu), веб-приложение «Edim menu» — своя статистика в Analytics.
  // Prod — environment.prod.ts
  firebaseAnalytics: {
    apiKey: "AIzaSyDZkA1i4AnV95bOje4Bye_tJrXXcxzmRrs",
    authDomain: "dev-edim-app.firebaseapp.com",
    projectId: "dev-edim-app",
    storageBucket: "dev-edim-app.appspot.com",
    messagingSenderId: "475056851053",
    appId: "1:475056851053:web:948a759de279b78b9e1764",
    measurementId: "G-2P79K0GXC1"
  },
  firebaseDatabase: {
    apiKey: "AIzaSyDZkA1i4AnV95bOje4Bye_tJrXXcxzmRrs",
    authDomain: "dev-edim-app.firebaseapp.com",
    projectId: "dev-edim-app",
    storageBucket: "dev-edim-app.appspot.com",
    messagingSenderId: "475056851053",
    appId: "1:475056851053:web:948a759de279b78b9e1764",
    measurementId: "G-2P79K0GXC1"
  }
};